import type { ExperimentValueUnion } from '@core/types'
import type { AssetAbManifest, AssetAbVariant, GameAssetTypesUnion, UseAssetAbTestsReturn } from '@game/types'

/** `useState` key the `game:asset-ab` plugin fills and `useAssetAbTests` reads. */
export const ASSET_AB_STATE_KEY = 'game:asset-ab'

// One `useAssetAbTests` instance per Nuxt app (per request on the server, per
// page-load on the client). Keyed on the app object rather than stored on it so
// nothing needs a `#app` type augmentation.
const instances = new WeakMap<object, UseAssetAbTestsReturn>()

export function assetAbTestsFor(app: object | null | undefined): UseAssetAbTestsReturn | undefined {
    return app ? instances.get(app) : undefined
}

export function rememberAssetAbTests(app: object, tests: UseAssetAbTestsReturn): UseAssetAbTestsReturn {
    instances.set(app, tests)

    return tests
}

export function forgetAssetAbTests(app: object): void {
    instances.delete(app)
}

/**
 * Pure lookup behind `useAssetAbTests().variantFor`. A test only applies to the
 * folder the manifest was published for, so assets served from a brand folder
 * (`asset_folders` or `brandGameAssets.folderName`) fall through to canonical.
 */
export function resolveAssetVariant(
    manifest: AssetAbManifest | null | undefined,
    bucket: ExperimentValueUnion,
    slug: string,
    type: GameAssetTypesUnion,
    siteFolder: string,
): AssetAbVariant | null {
    if (!manifest || manifest.siteFolder !== siteFolder) return null

    const test = manifest.tests[slug]
    if (!test || test.variant !== bucket || !test.files.includes(type)) return null

    return { suffix: `__${test.variant}`, t: test.t }
}
